import { GetAccommodationResponse } from '@orbit/api-types'

/**
 * Google Maps deep link for a stay's location: place-id lookup when we have
 * one, otherwise a text search on the stored address. Shared by the member and
 * public accommodation detail pages.
 */
export const getGoogleMapsUrl = (
	location: GetAccommodationResponse['location'],
): string | null => {
	if (!location) return null
	if (location.googlePlaceId) {
		return `https://www.google.com/maps/place/?q=place_id:${location.googlePlaceId}`
	}
	const query = location.fullText || location.primaryText
	if (query) {
		return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`
	}
	return null
}
